import React, { useEffect } from 'react'

/**
 * Hook to refresh data by user prevents RefreshControl jank
 * @see https://github.com/TanStack/query/issues/2380#issuecomment-912434275
 */

export function useRefreshByUser(
  refetch: () => Promise<unknown>,
  isRefetching: boolean
) {
  const [isFetching, setFetching] = React.useState(false)
  const [isRefetchingByUser, setIsRefetchingByUser] = React.useState(false)

  async function refetchByUser() {
    setFetching(true)

    try {
      await refetch()
    } finally {
      setFetching(false)
    }
  }

  useEffect(() => {
    if (isFetching === isRefetching) {
      setIsRefetchingByUser(isFetching)
    }
  }, [isRefetching, isFetching])

  return {
    isRefetchingByUser,
    refetchByUser,
  }
}
